import { Typography } from 'antd'
import { TextProps } from 'antd/es/typography/Text'
import { FC } from 'react'

const { Text } = Typography

type Props = TextProps & {}

const WalletDisclaimer: FC<Props> = ({ ...props }) => (
  <Text {...props}>
    This text will be visible on the Wallet pass.
    <br />
    <br />
    If not specified, the card number field won't be visible on the pass.
    <br />
    Changing this value won't affect existing passes. The only way to update a
    pass at the moment is to delete the existing pass and add it again from the
    app.
  </Text>
)

export default WalletDisclaimer
